import { Module } from 'vuex';
import { RootState } from '@/store/state';
import actions from '@/store/modules/merchant/actions';
import mutations from '@/store/modules/merchant/mutations';
import state, { MerchantState } from '@/store/modules/merchant/state';

const MerchantModule: Module<MerchantState, RootState> = {
  namespaced: true,
  state,
  actions,
  mutations,
};

export default MerchantModule;
